import { useOpenBankingAccounts } from '@features/openBanking/hooks/useOpenBankingAccounts'

export const useShouldConnectBank = (accountId: string) => {
  const { openBankingAccounts, isLoading: isLoadingOpenBankingAccounts } = useOpenBankingAccounts()

  const connectedBank = openBankingAccounts?.find(
    (openBankingAccount) => openBankingAccount.externalAccountId === accountId,
  )

  const hasConnectionError = !!connectedBank?.connection.requiresUpdate

  const shouldRenewBankConnection = hasConnectionError
  const shouldConnectBank = !connectedBank
  const isLoading = isLoadingOpenBankingAccounts

  return {
    isLoading,
    shouldConnectBank,
    shouldRenewBankConnection,
  }
}
